/* heyshappy.com, kolekcje sof (sekcja swp-coll3-kat), 09.10.2026. Kopia skryptu z heyshappy.pl.
   Zachowanie z sekcji swp-kolekcja (05.10): probki kolorow przelaczaja zdjecie, cene i link karty, skroty rozmiaru filtruja karty.
   Do tego powiekszenie tkaniny z sekcji swp-coll2-sofy. Napisy przychodza z sekcji w bloku [data-c2k-config]. Ladowany z defer.
   Bez skryptu strona dziala: probki sa linkami do wariantow, widac sofy wlasciwego rozmiaru. Nie wysyla zadnych zdarzen pomiarowych. */
(function () {
  'use strict';
  var root = document.getElementById('swp-c2k');
  if (!root || root.getAttribute('data-c2k-gotowe')) return;
  root.setAttribute('data-c2k-gotowe', '1');
  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-c2k-config]').textContent); } catch (e) {}
  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  var bezRuchu = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* podglad: linki do kolekcji wewnatrz sekcji zachowuja ?view=swp-coll2... */
  var view = (location.search.match(/[?&]view=(swp-coll3[\w-]*)/) || [])[1];
  if (view) $$('a[href*="/collections/"]').forEach(function (a) {
    var h = a.getAttribute('href'); if (h.indexOf('view=') > -1) return;
    a.setAttribute('href', h + (h.indexOf('?') < 0 ? '?' : '&') + 'view=' + (/\/collections\/sale(\?|$)/.test(h) ? 'swp-coll3-sale' : view));
  });

  $$('a[data-c2k-sw]').forEach(function (a) {
    a.setAttribute('role', 'button');
    a.setAttribute('aria-pressed', a.classList.contains('is-on') ? 'true' : 'false');
  });
  function ustawZdjecie(img, adres, alt) {
    if (!img || !adres) return;
    var szer = (img.getAttribute('data-szer') || '360,540,720').split(',');
    function w(n) { return adres.replace(/([?&]width=)\d+/, '$1' + n); }
    img.srcset = szer.map(function (n) { return w(n) + ' ' + n + 'w'; }).join(', ');
    img.src = w(szer[1] || szer[0]);
    if (alt) img.alt = alt;
  }
  function wysrodkuj(rzad, btn) {
    if (!rzad || rzad.scrollWidth <= rzad.clientWidth + 1) return;
    var x = Math.max(0, btn.offsetLeft - (rzad.clientWidth - btn.offsetWidth) / 2);
    try { rzad.scrollTo({ left: x, behavior: bezRuchu ? 'auto' : 'smooth' }); } catch (e) { rzad.scrollLeft = x; }
  }
  function wybierz(a) {
    var karta = a.closest('[data-c2k-karta]');
    if (!karta) return;
    function d(n) { return a.getAttribute('data-' + n) || ''; }
    $$('a[data-c2k-sw]', karta).forEach(function (b) {
      var on = b === a;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var el;
    if ((el = $('[data-c2k-color]', karta))) el.textContent = d('n');
    if ((el = $('[data-c2k-price]', karta))) el.textContent = d('p');
    if ((el = $('[data-c2k-was]', karta))) { el.textContent = d('w'); el.hidden = !d('w'); }
    if ((el = $('[data-c2k-sale]', karta))) el.hidden = !d('w');
    $$('[data-c2k-link]', karta).forEach(function (l) { l.setAttribute('href', a.getAttribute('href')); });
    ustawZdjecie($('[data-c2k-img]', karta), d('img'), (karta.getAttribute('data-alt') || '') + d('n'));
    wysrodkuj(a.parentNode, a);
  }
  function ustawRozmiar(r) {
    $$('[data-c2k-rozmiar]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c2k-rozmiar') === r ? 'true' : 'false'); });
    $$('[data-c2k-siatka] > li').forEach(function (li) { li.hidden = !(r === 'all' || li.getAttribute('data-rozmiar') === r); });
  }

  var modal = $('[data-c2k-modal]'), ostatni = null;
  function zamknij() { if (!modal || modal.hidden) return; modal.hidden = true; if (ostatni) ostatni.focus(); }
  function otworz(b) {
    if (!modal) return;
    var opis = $('[data-c2k-modal-opis]', modal), img = $('[data-c2k-modal-img]', modal), t = b.getAttribute('data-tytul');
    opis.textContent = '';
    ((cfg.fabric || {})[b.getAttribute('data-c2k-tk')] || []).forEach(function (x) { var p = document.createElement('p'); p.textContent = x; opis.appendChild(p); });
    img.src = b.getAttribute('data-src'); img.alt = (cfg.altTpl || '[v1]').replace('[v1]', t);
    $('[data-c2k-modal-tytul]', modal).textContent = t;
    $('[data-c2k-modal-link]', modal).href = b.getAttribute('data-url');
    ostatni = b; modal.hidden = false; $('.c2k-modal__x', modal).focus();
  }

  root.addEventListener('click', function (e) {
    var t = e.target, b;
    if (!t || !t.closest) return;
    if ((b = t.closest('a[data-c2k-sw]'))) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      e.preventDefault(); wybierz(b); return;
    }
    if ((b = t.closest('[data-c2k-rozmiar]'))) { ustawRozmiar(b.getAttribute('data-c2k-rozmiar')); return; }
    if ((b = t.closest('[data-c2k-tk]'))) { otworz(b); return; }
    if (t.closest('[data-c2k-zamknij]')) zamknij();
  });
  root.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Spacebar') return;
    var b = e.target && e.target.closest && e.target.closest('a[data-c2k-sw]');
    if (b) { e.preventDefault(); wybierz(b); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') zamknij(); });
})();
